import { Fieldset } from '@calendly/form/parts'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { RadioField } from '@calendly/ui/form/radio-field'
import { useState } from 'react'

import { usePublisherWorkflowsModalT } from 'features/workflows/modals/use_publisher_workflows_modal_t'

import {
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_MEETING_SCHEDULED
} from './consts'
import {
  GroupBlock,
  TimingOptionsBlock,
  WhenBlock,
  WhenRow
} from './styles'
import { SubTitle } from '../../../styles'


function WhenGroup({ onChange, triggerType, wfT }) {
  const defaultChecked = triggerType === BOOKING_WHEN_INVITEE_BOOKED

  return (
    <WhenBlock>
      <WhenRow>
        <RadioField
          checked={defaultChecked}
          onChange={() => { onChange(BOOKING_WHEN_INVITEE_BOOKED) }}
          label={wfT('publisher.workflows.triggers.booking.when.invitee_booked.group.each_invitee')}
        />
      </WhenRow>
      <WhenRow>
        <RadioField
          checked={!defaultChecked}
          onChange={() => { onChange(BOOKING_WHEN_MEETING_SCHEDULED) }}
          label={wfT('publisher.workflows.triggers.booking.when.invitee_booked.group.only_first')}
        />
      </WhenRow>
    </WhenBlock>
  )
}

function GroupToggle({ opened, onClick, wfT }) {
  const toggleCopy = opened
    ? wfT('publisher.workflows.triggers.booking.when.invitee_booked.group.hide_options')
    : wfT('publisher.workflows.triggers.booking.when.invitee_booked.group.show_options')
  return (
    <MinimalButton fontSize="medium" aria-expanded={opened} onClick={onClick}>
      {toggleCopy}
    </MinimalButton>
  )
}

export const GroupTriggers = (props) => {
  const { triggerType } = props
  const wfT = usePublisherWorkflowsModalT()
  const [opened, setOpened] = useState(false)
  const toggle = () => setOpened((prevValue) => !prevValue)
  const validTypes = [BOOKING_WHEN_INVITEE_BOOKED, BOOKING_WHEN_MEETING_SCHEDULED]

  if (!validTypes.includes(triggerType)) { return null }

  return (
    <>
      {opened && (
        <GroupBlock>
          <Fieldset>
            <SubTitle as="legend">
              {wfT('publisher.workflows.triggers.booking.when.invitee_booked.group.subtitle')}
            </SubTitle>
            <TimingOptionsBlock>
              <WhenGroup {...props} wfT={wfT} />
            </TimingOptionsBlock>
          </Fieldset>
        </GroupBlock>
      )}
      <GroupToggle opened={opened} onClick={toggle} wfT={wfT} />
    </>
  )
}
